import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Box, Grid, Button, Typography, Tooltip, IconButton, Chip, TextField, InputBase, Divider, Snackbar, Alert, Modal, FormHelperText, Card, CardContent, Avatar, Stack } from '@mui/material';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Skeleton from '@mui/material/Skeleton';
import FilterListIcon from '@mui/icons-material/FilterList';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import CallIcon from '@mui/icons-material/Call';
import SearchIcon from '@mui/icons-material/Search';
import CachedIcon from '@mui/icons-material/Cached';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";

import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { Email, MoreVert, Phone } from '@mui/icons-material';
import PersonIcon from '@mui/icons-material/Person';
import PhoneIcon from '@mui/icons-material/Phone';
import WorkIcon from '@mui/icons-material/Work';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};



export const LeadsComp = (props) => {


    const FormatDateTime = (date) => {
        let formatDate = new Date(new Date(date).getTime() - (new Date(date).getTimezoneOffset() * 60000)).toISOString().substr(0, 19).replace('T', ' ')
        return (formatDate);
    }

    return (
        <Box>
            <Box>
                <Grid container>
                    <Grid md={4} mt={2}>
                        <Box>
                            <Paper
                                component="form"
                                sx={{ p: '2px 4px', height: 40, display: 'flex', alignItems: 'center', width: '100%' }}
                            >
                                <InputBase
                                    sx={{ ml: 1, flex: 1 }}
                                    placeholder="Search By Name, Number, ID..."
                                    inputProps={{ 'aria-label': '' }}
                                    value={props.mystate.leadObj.txtLeadSearchName || ''}
                                    onChange={(e) => props.HandleInputs(e, 'txtLeadSearchName')}
                                />
                                <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
                                    <SearchIcon onClick={() => props.SearchLeadList('direct', '')} />
                                </IconButton>
                                <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
                                <IconButton color="" sx={{ p: '10px' }} aria-label="directions">
                                    <CachedIcon onClick={() => props.SearchLeadList('reload', '')} />
                                </IconButton>
                            </Paper>

                        </Box>
                    </Grid>
                    <Grid md={3} mt={2}>
                        {
                            props.mystate.userData.profile !== 'Telecaller' && props.mystate.userData.profile !== 'German Teacher' ?
                                <FormControl sx={{ m: 1, minWidth: 200, marginTop: 0.2, }} size="small">
                                    <TextField
                                        size='small'
                                        select
                                        //  value={props.mystate.leadObj.ddlCandidateStatus}
                                        value={props.mystate.leadObj.ddlCandidateStatus || ''}
                                        label="Status"
                                        onChange={(e) => props.HandleInputs(e, 'ddlCandidateStatus')}
                                    >
                                        {
                                            props.mystate.userData.profile === 'Admin' || props.mystate.userData.profile === 'Marketing' ?
                                                <MenuItem value={'Not Shortlisted'}>{'Not Shortlisted'}</MenuItem>
                                                :
                                                null
                                        }
                                        <MenuItem value={'Shortlisted'}>{'Shortlisted'}</MenuItem>
                                        <MenuItem value={'On Board'}>{'On Board'}</MenuItem>
                                    </TextField>
                                </FormControl>
                                :
                                null
                        }
                    </Grid>

                    <Grid md={5} mt={2} style={{ textAlign: 'right' }}>
                        <Tooltip arrow title="New Lead">
                            <IconButton onClick={() => props.NavigateTo('lead/new')} className='grey-theme-btn'>
                                <AddIcon />
                            </IconButton>
                        </Tooltip>
                        {/* <Button className='grey-theme-btn' variant="outlined" onClick={() => props.NavigateTo('lead/new')} startIcon={<AddIcon />}>
                            Add New Lead
                        </Button> */}
                        <Tooltip arrow title="Filter list">
                            <IconButton onClick={() => props.ToggleFilter()} className='grey-theme-btn'>
                                <FilterListIcon />
                            </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
            </Box>
            <Box style={{ marginTop: '20px' }}>
                {
                    props.mystate.getLeadList == false ?
                        window.innerWidth > 567 ?
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 'calc(100vh - 250px)' }}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell
                                                    key={'SrNo'}
                                                    align={'left'}
                                                    width={50}
                                                    className='table-head-cell'
                                                >
                                                    {'SrNo'}
                                                </TableCell>
                                                <TableCell
                                                    key={'Lead Date'}
                                                    align={'left'}
                                                    width={100}
                                                    className='table-head-cell'
                                                >
                                                    {'Lead Date'}
                                                </TableCell>

                                                <TableCell
                                                    key={'User Details'}
                                                    align={'left'}
                                                    width={150}
                                                    className='table-head-cell'
                                                >
                                                    {'User Details'}
                                                </TableCell>
                                                <TableCell
                                                    key={'Owner'}
                                                    align={'left'}
                                                    width={100}
                                                    className='table-head-cell'
                                                >
                                                    {'Owner'}
                                                </TableCell>



                                                <TableCell
                                                    key={'Source'}
                                                    align={'left'}
                                                    width={70}
                                                    className='table-head-cell'
                                                >
                                                    {'Source'}
                                                </TableCell>
                                                <TableCell
                                                    key={'Status'}
                                                    align={'left'}
                                                    width={70}
                                                    className='table-head-cell'
                                                >
                                                    {'Status'}
                                                </TableCell>

                                                {
                                                    props.mystate.leadObj.ddlCandidateStatus === 'Shortlisted' ?
                                                        <TableCell
                                                            key={'Interview Details'}
                                                            align={'left'}
                                                            width={150}
                                                            className='table-head-cell'
                                                        >
                                                            {'Interview Details'}
                                                        </TableCell>
                                                        :
                                                        props.mystate.leadObj.ddlCandidateStatus === 'On Board' ?
                                                            <TableCell
                                                                key={'Joining Details'}
                                                                align={'left'}
                                                                width={150}
                                                                className='table-head-cell'
                                                            >
                                                                {'Interview Details'}
                                                            </TableCell>
                                                            : null
                                                }

                                                <TableCell
                                                    key={''}
                                                    align={'left'}
                                                    width={100}
                                                    className='table-head-cell'
                                                >
                                                    {''}
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {props.mystate.leadList != undefined && props.mystate.leadList.length > 0 ?
                                                props.mystate.leadList.map((item, i) => (
                                                    <TableRow hover role="checkbox" tabIndex={-1} key={item._id}>
                                                        <TableCell key={props.mystate.totalRecords + i + 1} align={'left'}>
                                                            {((props.mystate.setNo - 1) * props.mystate.perSet) + i + 1}
                                                        </TableCell>
                                                        <TableCell key={item.createdAt + i} align={'left'}>
                                                            {FormatDateTime(item.createdAt)}
                                                        </TableCell>
                                                        <TableCell key={item.user_name + i} align={'left'}>
                                                            <span>{item.user_name}</span>
                                                            <br></br>
                                                            {
                                                                props.mystate.userData.profile !== 'Marketing' ?
                                                                    <strong><span>({item.user_mobile})</span></strong>
                                                                    :
                                                                    null
                                                            }
                                                        </TableCell>
                                                        <TableCell key={item.lead_owner + i} align={'left'}>
                                                            {item.lead_owner}
                                                            <br></br>
                                                            <strong><span>({item.lead_dept})</span></strong>
                                                        </TableCell>

                                                        <TableCell key={item.lead_source + i} align={'left'}>
                                                            {item.lead_source}
                                                        </TableCell>
                                                        <TableCell key={item.lead_status + i} align={'left'}>
                                                            <Chip sx={{ backgroundColor: '#042740', color: '#fff' }} label={props.mystate.leadObj.ddlCandidateStatus === 'Shortlisted' ? item.lead_status : props.mystate.leadObj.ddlCandidateStatus === 'On Board' ? item.lead_status : item.lead_status} />
                                                        </TableCell>

                                                        {


                                                            props.mystate.leadObj.ddlCandidateStatus === 'Shortlisted' ?
                                                                <TableCell key={item.interviewer_name + i} align={'left'}>
                                                                    {item.interviewer_name}
                                                                    <br></br>
                                                                    <strong><span>{item.interview_date}</span></strong>
                                                                </TableCell>
                                                                :
                                                                props.mystate.leadObj.ddlCandidateStatus === 'On Board' ?
                                                                    <TableCell key={item.joining_class_mode + i} align={'left'}>
                                                                        {item.joining_class_mode}
                                                                        <br></br>
                                                                        <strong><span>({item.joining_date})</span></strong>
                                                                    </TableCell>
                                                                    : null


                                                        }



                                                        <TableCell key={item.cust_added_on + i}>
                                                            {/* {
                                                                props.mystate.leadObj.ddlCandidateStatus === 'Not Shortlisted' || props.mystate.leadObj.ddlCandidateStatus === '' ?
                                                                    <Tooltip arrow title='Make Call'>
                                                                        <Button><CallIcon className='grey-theme-btn' onClick={() => props.MakeNewCall(item)}></CallIcon></Button>
                                                                    </Tooltip>
                                                                    :
                                                                    null
                                                            } */}

                                                            <Tooltip arrow title='Lead Details'>
                                                                <Button><EditIcon className='grey-theme-btn' onClick={() => props.NavigateTo('lead/' + item._id)}></EditIcon></Button>
                                                            </Tooltip>

                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                                :
                                                <Box>
                                                    <Typography variant='h6' component="h6" color={'black'}></Typography>
                                                </Box>
                                            }
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[10, 50, 100, 200, 300]}
                                    component="div"
                                    count={props.mystate.totalRecords}
                                    rowsPerPage={props.mystate.perSet}
                                    // page={props.mystate.setNo == 1 ? 1 + '-' + props.mystate.perSet : props.mystate.perSet * (props.mystate.setNo - 1) + '-' + props.mystate.perSet * (props.mystate.setNo) }
                                    page={props.mystate.setNo - 1}
                                    onPageChange={(e) => props.HandleChangePage(e, props.mystate.setNo - 1)}
                                    //onPageChange={handleChangePage}
                                    onRowsPerPageChange={(e) => props.HandleChangeRowsPerPage(e)}
                                />
                            </Paper>
                            :
                            <Box>

                                {props.mystate.leadList != undefined && props.mystate.leadList.length > 0 ?
                                    props.mystate.leadList.map((item, i) => (

                                        <Grid item xs={12} sm={6} md={4} lg={3} key={item._id}>
                                            <Card
                                                variant="outlined"
                                                sx={{
                                                    height: 180,
                                                    borderRadius: 3,
                                                    boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                                                    transition: '0.3s ease',
                                                    position: 'relative',
                                                    overflow: 'hidden',
                                                    '&:hover': {
                                                        boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
                                                        transform: 'translateY(-2px)',
                                                    },
                                                }}
                                            >
                                                <CardContent sx={{ p: 2, height: '100%' }}>
                                                    {/* Header Row */}
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Typography variant="subtitle2" color="text.secondary">
                                                            {new Date(item.createdAt).toLocaleDateString()}
                                                        </Typography>
                                                        <Chip
                                                            label={item.lead_status}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: '#042740',
                                                                color: '#fff',
                                                                fontSize: '0.7rem',
                                                                borderRadius: '6px',
                                                                height: 22,
                                                            }}
                                                        />
                                                    </Box>

                                                    {/* Main Details */}
                                                    <Box sx={{ mt: 1.2 }}>
                                                        <Typography
                                                            variant="subtitle1"
                                                            sx={{
                                                                fontWeight: 600,
                                                                color: '#042740',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: 0.6,
                                                            }}
                                                        >
                                                            <PersonIcon sx={{ fontSize: 18, color: '#042740' }} />
                                                            {item.user_name}
                                                        </Typography>
                                                        <Typography
                                                            variant="body2"
                                                            color="text.secondary"
                                                            sx={{ display: 'flex', alignItems: 'center', gap: 0.6 }}
                                                        >
                                                            <PhoneIcon sx={{ fontSize: 16, color: '#666' }} />
                                                            {item.user_mobile}
                                                        </Typography>
                                                    </Box>

                                                    {/* Divider */}
                                                    <Divider sx={{ my: 1 }} />

                                                    {/* Owner + Source */}
                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <Box>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
                                                            >
                                                                <WorkIcon sx={{ fontSize: 16, color: '#555' }} />
                                                                {item.lead_owner}
                                                            </Typography>
                                                            <Typography variant="caption" color="text.secondary">
                                                                {item.lead_source}
                                                            </Typography>
                                                        </Box>

                                                        {/* Action Buttons */}
                                                        <Box sx={{ display: 'flex', gap: 1 }}>
                                                            <Tooltip title="Call">
                                                                <IconButton
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor: '#042740',
                                                                        color: '#fff',
                                                                        '&:hover': { backgroundColor: '#06375d' },
                                                                        p: 0.7,
                                                                    }}
                                                                    onClick={() => props.MakeNewCall(item)}
                                                                >
                                                                    <CallIcon sx={{ fontSize: 18 }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                            <Tooltip title="Details">
                                                                <IconButton
                                                                    size="small"
                                                                    sx={{
                                                                        backgroundColor: '#e5e8eb',
                                                                        color: '#042740',
                                                                        '&:hover': { backgroundColor: '#d6d8db' },
                                                                        p: 0.7,
                                                                    }}
                                                                    onClick={() => props.NavigateTo('lead/' + item._id)}
                                                                >
                                                                    <EditIcon sx={{ fontSize: 18 }} />
                                                                </IconButton>
                                                            </Tooltip>
                                                        </Box>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </Grid>

                                    )) : ''}

                            </Box>

                        :

                        <Box>
                            <Skeleton height={75} />
                            <Skeleton animation="wave" variant="rectangular" height={250} />
                            <Skeleton height={75} />
                        </Box>
                }

            </Box>


            <Snackbar open={props.mystate.showAlert} autoHideDuration={1000} onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}>
                <Alert
                    onClose={() => { props.HandleCloseAlertMsg(props.mystate.alertType) }}
                    severity={props.mystate.alertType}
                    variant="filled"
                    sx={{ width: '100%' }}

                >
                    {props.mystate.alertMsg}
                </Alert>
            </Snackbar>


            <Modal
                open={props.mystate.openInteractionBox}
                // onClose={() => props.ToggleInteractionBox()}
                onClose={(event, reason) => {
                    // ❌ Prevent close when clicking backdrop
                    if (reason === "backdropClick") return;
                    props.ToggleInteractionBox()
                }}
                // hideBackdrop={true}
                disableEscapeKeyDown={true}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-Interaction"
            >
                <Box sx={style}>
                    <Typography className='grey-theme-btn' variant="h6" component="h2">
                        Add Interaction
                    </Typography>
                    <Box mt={1}>
                        <FormControl fullWidth>
                            <TextField
                                select
                                value={props.interactionData.ddlLeadStatus || ''}
                                label="Select Status*"
                                error={props.interactionData.ddlLeadStatusErr == undefined || props.interactionData.ddlLeadStatusErr == '' ? false : true}
                                onChange={(e) => props.HandleInputs(e, 'ddlLeadStatus')}
                            >
                                {
                                    props.mystate.userData.allowedStages.map((item, i) =>
                                        <MenuItem key={i} value={item}>{item}</MenuItem>
                                    )
                                }


                            </TextField>
                            <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadStatusErr}</FormHelperText>
                        </FormControl>
                    </Box>
                    {
                        props.interactionData.ddlLeadStatus === 'Call Back' ?
                            <Box mt={1}>
                                <Box>
                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                        <DemoContainer components={['DateTimePicker']}>
                                            <DateTimePicker minDate={dayjs(new Date())} sx={{ width: '100%' }} onChange={(e) => props.HandleInputs(e, 'txtCallBackDateTime')} label="CallBack DateTime*" value={dayjs(props.interactionData.txtCallBackDateTime != undefined ? props.interactionData.txtCallBackDateTime : '')} slotProps={{
                                                textField: {
                                                    error: props.interactionData.txtCallBackDateTimeErr == undefined || props.interactionData.txtCallBackDateTimeErr == '' ? false : true,
                                                },
                                            }} />
                                        </DemoContainer>
                                    </LocalizationProvider>
                                </Box>
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtCallBackDateTimeErr}</FormHelperText>

                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlLeadStatus === 'Dead' ?
                            <Box mt={1}>
                                <TextField multiline rows={2} className="text-input" id="txtDeadReason" name='txtDeadReason' error={props.interactionData.txtDeadReasonErr == undefined || props.interactionData.txtDeadReasonErr == '' ? false : true} helperText={props.interactionData.txtDeadReasonErr} onChange={(e) => props.HandleInputs(e, 'txtDeadReason')} value={props.interactionData.txtDeadReason || ''} label="Dead Reason" variant="outlined" />
                                <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.txtDeadReasonErr}</FormHelperText>
                            </Box>
                            :
                            null
                    }

                    {
                        props.interactionData.ddlLeadStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadDepartment || ''}
                                        label="Select Department*"
                                        error={props.interactionData.ddlLeadDepartmentErr == undefined || props.interactionData.ddlLeadDepartmentErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadDepartment')}
                                    >
                                        <MenuItem value={'Sales TL'}>{'Sales TL'}</MenuItem>
                                        <MenuItem value={'Sales'}>{'Sales'}</MenuItem>
                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadDepartmentErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }
                    {
                        props.interactionData.ddlLeadStatus === 'In Progress' ?
                            <Box mt={1}>
                                <FormControl fullWidth>
                                    <TextField
                                        select
                                        value={props.interactionData.ddlLeadOwner || ''}
                                        label="Select Owner*"
                                        error={props.interactionData.ddlLeadOwnerErr == undefined || props.interactionData.ddlLeadOwnerErr == '' ? false : true}
                                        onChange={(e) => props.HandleInputs(e, 'ddlLeadOwner')}
                                    >
                                        {
                                            props.mystate.userListData.map((item, i) =>
                                                item.user_profile_name === props.interactionData.ddlLeadDepartment ?
                                                    <MenuItem key={i} value={item.user_name}>{item.user_name}</MenuItem>
                                                    :
                                                    null
                                            )
                                        }


                                    </TextField>
                                    <FormHelperText style={{ color: '#d32f2f' }}>{props.interactionData.ddlLeadOwnerErr}</FormHelperText>
                                </FormControl>
                            </Box>

                            :
                            null
                    }



                    <Box mt={1}>
                        <TextField multiline rows={4} className="text-input" id="txtInteractionDesc" name='txtInteractionDesc' error={props.interactionData.txtInteractionDescErr == undefined || props.interactionData.txtInteractionDescErr == '' ? false : true} helperText={props.interactionData.txtInteractionDescErr} onChange={(e) => props.HandleInputs(e, 'txtInteractionDesc')} value={props.interactionData.txtInteractionDesc || ''} label="Enter Description" variant="outlined" />
                        <FormHelperText style={{ fontSize: 10, textAlign: 'end', color: '#042740', fontWeight: 'bold' }}>{'Max Char. 60'}</FormHelperText>
                    </Box>
                    <Box mt={2}>
                        <Grid container>
                            <Grid>
                                <Button className='grey-theme-btn' variant="outlined" onClick={() => props.AddNewInteraction()}>Add Interaction</Button>
                            </Grid>

                        </Grid>
                    </Box>

                </Box>
            </Modal>



        </Box>


    );
}